// extracted by mini-css-extract-plugin
export default {"external":"acKOpW","deprecatedBorderRadius":"bcKOpW","hasAnimation":"ccKOpW","container":"dcKOpW"};